const status = ['single', 'married', 'divorced', 'separated', 'widowed']

const civil_status = status.map((item) => ({
  label: item.toUpperCase(),
  value: item,
}))

export default civil_status



// WEBPACK FOOTER //
// ./src/constants/civil_status.js